<template>
  <div class="od-card-container margin-bottom-8">
    <div class="odc-header-container">
      <div class="odc-header">
        Company Information
      </div>
    </div>
    <div class="odc-body-container">
      <div class="odcb-info-container">
        <div class="odcb-body">
          {{ order.corporation.corporationName }}
        </div>
        <div class="odcb-body">
          {{ order.corporation.address1 }}
        </div>
        <div
          v-if="order.corporation.address2"
          class="odcb-body"
        >
          {{ order.corporation.address2 }}
        </div>
        <div class="odcb-body">
          {{ order.corporation.city }},
          {{ order.corporation.state }}
          {{ order.corporation.zip }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'CompanyInformation',
  mixins: [partnerReviewMixin],
};
</script>
